import OnSuccessDelegate from '../../types/OnSuccessDelegate'
import { Dispatch } from 'react'
import { MoreAboutMeState } from './store/State'
import { MoreAboutMeAction, setResponse } from './store/Actions'
import { IResponseUpdateRequestPayload, IResponsesUpdateRequestPayload } from 'types'
export default class MoreAboutMeService {
  static handleUpdateResponses(
    responses: MoreAboutMeState,
    state: MoreAboutMeState,
    updateResponses: OnSuccessDelegate<IResponsesUpdateRequestPayload>
  ) {
    return () => {
      const keys = Object.keys(state)
      const responsesToUpdate = keys.reduce((result, key) => {
        if (state[key] !== responses[key]) {
          result.push({
            questionKey: key,
            response: key === 'impactGoodAt' ? state[key]?.replace(/\.+$/, '') : state[key]
          })
        }
        return result
      }, [])

      if (responsesToUpdate.length) {
        return updateResponses({ responses: responsesToUpdate })
      }
    }
  }

  static handleChangeResponse(dispatch: Dispatch<MoreAboutMeAction>) {
    return ({ questionKey, response }: IResponseUpdateRequestPayload) => {
      dispatch(setResponse({ questionKey, response }))
    }
  }
}
